import { useNavigate } from "react-router-dom";
import question from "../../../assets/images/question.svg";

const SupportButton = () => {
  const navigate = useNavigate();
  return (
    <div>
      <img
        onClick={() => navigate("/support")}
        className="cursor-pointer"
        src={question}
        alt="question"
      />
    </div>
  );
};

export default SupportButton;
